export default "__VITE_ASSET__9d88e5b5__"